import script from "./bankCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./bankCard.vue?vue&type=script&lang=ts&setup=true"

import "./bankCard.vue?vue&type=style&index=0&id=f7e5c1fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7e5c1fe"]])

export default __exports__